import { useState } from "react";
import {
  useRemoveUserAvatarMutation,
  useUploadUserAvatarMutation,
} from "entities/user";
import type { ApiError } from "shared/utils";
import { getAvatarError } from "./getAvatarError";
import { validateAvatarFile } from "./validateAvatarFile";

interface UseAvatarResult {
  upload: (file: File) => Promise<void>;
  remove: () => Promise<void>;
  isBusy: boolean;
  error: string | null;
}

export const useAvatar = (): UseAvatarResult => {
  const [uploadAvatar, uploadState] = useUploadUserAvatarMutation();
  const [removeAvatar, removeState] = useRemoveUserAvatarMutation();
  const [error, setError] = useState<string | null>(null);

  const handleResult = (result: { error?: ApiError }) =>
    setError(getAvatarError(result.error));

  const upload = async (file: File) => {
    const validationError = validateAvatarFile(file);
    setError(validationError);
    if (validationError) return;
    handleResult(await uploadAvatar(file));
  };

  const remove = async () => {
    setError(null);
    handleResult(await removeAvatar());
  };

  return {
    upload,
    remove,
    isBusy: uploadState.isLoading || removeState.isLoading,
    error,
  };
};
